import React from 'react';

/**
 * TemplateAdapter - Compatibilidade com componente Template do integrar-skin
 * No manager-cob, apenas renderiza children sem wrapper especial
 */
const TemplateAdapter = ({ children }) => {
  return (
    <div className="page">
      <div className="page-content">
        {children}
      </div>
    </div>
  );
};

export default TemplateAdapter;
